import { Footer } from "@/components/layout/Footer";
import { Button } from "@/components/ui/button";

interface HomePageProps {
  onStartCalculator: () => void;
}

export const HomePage = ({ onStartCalculator }: HomePageProps) => {
  return (
    <div className="relative h-screen overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-contain bg-center bg-no-repeat"
        style={{
          backgroundImage: "url(/images/home-background.png)",
        }}
      />

      <div className="flex h-full flex-col">
        {/* Main Content */}
        <main className="container relative z-10 mx-auto flex-1 px-8 pt-10">
          {/* ULTOMIRIS Logo */}
          <div className="flex w-full justify-center lg:justify-start">
            <img
              src="/images/logos/ultomiris-logo.svg"
              alt="ULTOMIRIS Logo"
              className="h-32 xl:h-40"
            />
          </div>
          <div className="grid grid-cols-1 items-center gap-4 sm:gap-20 md:grid-cols-2">
            {/* Left Side - Logo and Vials */}
            <div className="order-2 flex flex-col items-start sm:space-y-12 lg:order-1">
              {/* Vials Illustration */}
              <div className="hidden items-center justify-center sm:flex">
                <img
                  src="/images/vials.png"
                  alt="ULTOMIRIS Vials"
                  className="relative z-10 w-full max-w-sm pt-10"
                />
              </div>
            </div>

            {/* Right Side - Content */}
            <div className="order-2 mt-16 space-y-8 text-center sm:mt-0 sm:text-start">
              <div className="space-y-6">
                <h1 className="text-2xl font-bold leading-[1.1] text-gray-800 sm:text-4xl xl:text-6xl">
                  Your Dosing Guide for
                  <br />
                  Your Patients
                </h1>
                <p className="text-lg font-normal leading-relaxed text-gray-700 md:text-xl">
                  Step-by-step dosing guidance tailored to support
                  <br />
                  optimal care for your patients
                </p>
              </div>

              {/* Action Button */}
              <div className="flex w-full justify-center pt-4">
                <Button
                  onClick={onStartCalculator}
                  className="hover:shadow-3xl transform rounded-full bg-[#FF6A39] px-12 py-7 text-xl font-semibold text-white shadow-2xl transition-all duration-200 hover:scale-105 hover:bg-[#E55A32]"
                >
                  Start Now
                </Button>
              </div>
            </div>
          </div>
        </main>

        {/* Footer */}
        <div className="mt-auto">
          <Footer />
        </div>
      </div>
    </div>
  );
};
